import type {FC} from 'react'

interface Props {
  type?: string
  list?: string[]
  dataState: [string, (data: string) => void]
}

const DropdownDefault: FC<Props> = ({type, list, dataState}) => {
  const [data, setData] = dataState
  return (
    <div className='dropdown'>
      <button
        className='btn btn-secondary dropdown-toggle'
        type='button'
        data-bs-toggle='dropdown'
        aria-expanded='false'
      >
        {`${type}: ${data || 'none'}`}
      </button>
      <ul className='dropdown-menu'>
        {list?.map((item, index) => (
          <li key={index}>
            <button onClick={() => setData(item)} className='dropdown-item' type='button'>
              {item}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default DropdownDefault
